import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div className="hs-section">
      <div className="hs-image">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla7.webp?alt=media&token=1d367970-1228-46d9-bc5e-b192f5335619"
          alt="Luxury Villa"
        />
      </div>
      <div className="hs-text">
        <p className="hs-label">Our Collections</p>
        <h1 className="hs-title">Curated Villa Collections</h1>
        <p className="hs-desc">Discover our portfolio of luxury villas — each collection thoughtfully crafted for a unique lifestyle experience across the world's most sought-after destinations.</p>
        <Link to='/our-collections'><button className="hs-btn">Explore Collections</button></Link>
      </div>    
      </div>
  );
};

export default AboutSection;
